import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { MatchDetail } from "@app/core/match/domain/model/match-detail";
import { MatchDetailMapper } from "@app/core/match/data/network/match-detail.mapper";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { HandlerBuilder, HttpMethod } from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
export const LOADING_SECTION_PROVABILITY = new InjectionToken<number>(
  "LOADING_SECTION_PROVABILITY"
);

@Injectable({
  providedIn: "root",
})
/**
 * Fake WS to get match detail
 */
export class MatchDetailSampleWS {
  constructor(private handler: BaseHandler) {}
  execute(token: string): Observable<MatchDetail> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.SAMPLE_STATISTICS_ENDPOINT())
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.handler
      .execute(parameters)
      .pipe(map((response) => {
        return MatchDetailMapper.deserialize(response);
      }));
  }
}